export default {
  title: 'Reservierungen CSV',
  buttons: {
    generate: 'Generieren & herunterladen',
  },
  fields: {
    date_range: 'Datumsbereich (optional)',
  },
  errors: {
    invalid_date_range: 'Bitte wählen Sie ein gültiges Datumsbereich',
  },
};
